import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, HeadingStyled, LazyImage, MainHeading, SpanStyled, TextStyled } from '../../../ui/Elements'
import { AboutBg, AboutImg, ArrowBtnBrown, PartnerImg, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr } from '../../../ui/AllImages'

import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../../ui/CustomElements'
import { WhyChooseData } from '../../projectData/Data'
import CeoMessage from '../ceo/CeoMessage'

const WhyChoose = () => {
    const { t } = useTranslation()
    
    return (
        <Box  id='whyChooseUs'>
            <WhyChooseWapper className='container-fluid secWhyChoose common-space'>
                <Container>
                    <Row className='choose-row'>
                        <Col md={12} className='centerHeadContainer'>
                            <MainHeading className='main-heading mb-3 main-heading-choose'>
                                {t('partnerHeading')}
                            </MainHeading>
                            <SpanStyled className='chooseDesc mb-4' size="22px">
                                {t('partnerText')}
                            </SpanStyled>
                        </Col>
                        

                        <Col lg={6} md={12} className='why-choose-col why-choose-col-img'>
                            <Box className='chooseImg'>
                                <LazyImage src={PartnerImg} />
                                
                            </Box>
                            
                            
                        </Col>
                        <Col lg={6} md={12} className='about-arabic'>
                        
                            <Box className='whyChooseContent'>
                                {WhyChooseData.map((list, key) => (
                                    <Box key={key} className='why-c-wapper'>
                                        
                                        <Box className='w-choose-content'>
                                            <Box className='w-choose-icon'>
                                                {list.img}
                                            </Box>
                                            
                                            <Box>
                                                <HeadingStyled color='var(--themeColor)' className='mb-1'>
                                                    {list.render && list.render(t)}
                                                    {/* {t(list.heading)} */}
                                                </HeadingStyled>
                                                <TextStyled>{t(list.text)}</TextStyled>
                                            </Box>
                                        </Box>
                                            
                                    </Box>
                                    ))
                                }
                                

                               
                                
                            </Box>
                        </Col>
                        
                    </Row>
                </Container>
                
            </WhyChooseWapper>
            <CeoMessage />
        </Box>
    )
}
const WhyChooseWapper = styled.section`
    .choose-row {
        align-items: center;
    }
    .whyChooseContent{
        padding-left: 20px;
        padding-right: 20px;
    }
    .w-choose-icon{
        display: flex;
        min-width: 78px;
        max-width: 78px;
        height: 78px;
        border: 1px solid var(--text2);
        border-radius: 50%;
        align-items: center;
        justify-content: center;
    }
    .chooseImg{
        border-radius: 24px;
        overflow: hidden;
        span{
            width: 100%;
            height: 100%;
            img{
                width: 100%;
                height: auto;
            }
        }
    }
    .centerHeadContainer{
        display: flex;
        width: 100%;
        justify-content: center;
        padding-left: 200px;
        padding-right: 200px;
        flex-wrap: wrap;
        padding-bottom: 20px;
        & > *{
            text-align: center;
            width: 100%;

        }
    }
    .why-c-wapper{
        margin: 20px 0;
    }
    .w-choose-content{
        display: flex;
        align-items: flex-start;
        gap: 12px;
        &>div{
            width:100%;
        }
    }
    
    body.rtl &{
        .abtHeadSec{
            font-size: 24px;
        }
        .whyChooseContent{
            padding-right: 20px;
            padding-left: 20px;
        }
        .centerHeadContainer{
            span{
                font-size: 24px;
            }
            
        }
    }
    @media (max-width: 1199px) {
        .whyChooseContent {
            padding-right: 30px;
        }
        body.rtl &{
            .whyChooseContent{
                padding-right: 0px;
                padding-left: 30px;
            }
        }
    }
    @media (max-width: 991px) {
        .why-choose-col{
            margin-bottom: 40px;
        }
        .why-choose-col-img{
            display: none;
        }
        &.secWhyChoose{
            padding-top: 60px;
            padding-bottom: 120px;
        }
        .main-heading-choose{
            font-size: 35px;
        }
        .whyChooseContent{
            padding-right: 0;
            padding-left: 0;
        }
        .centerHeadContainer{
            padding-left: calc(var(--bs-gutter-x) * .5);
            padding-right: calc(var(--bs-gutter-x) * .5);
        }
        .chooseDesc{
            font-size: 18px;
        }
        body.rtl &{
            .whyChooseContent{
                padding-right: 0px;
                padding-left: 0px;
            }
            span.chooseDesc{
                font-size: 18px;
            }
        }
        
    }
    @media (max-width: 767px) {
        
    }
    @media (max-width: 575px) {
        &.secWhyChoose{
            padding-top: 50px;
            padding-bottom: 90px;
        }
        .main-heading-choose{
            font-size: 30px;
        }
    }
`
export default WhyChoose
